import styled from 'styled-components';
import {Theme} from './../../../../stories/theme/types';
import {RowStyles, ColumnStyles} from './../../../../stories/core-components/Layouts/Layouts';

export const TabIconWrap = styled.span(
  (props: ThemeProps<Theme>) => `
    margin-right: 0.5rem;
    display: flex;
  `,
);

export const SearchIconWrap = styled.span(
  (props: ThemeProps<Theme>) => `
   position: absolute;
   top:0.2rem;
   right: 0.2rem;
   padding:1rem;
   background: white
  `,
);

export const FiltersBlockLayoutDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}

  width:100%;
  background-color:${props.theme.colors.white.base};
  margin-bottom:${props.theme.spacing.base};
  border-radius:${props.theme.misc.borderRadius.custom(6)};
`,
);

export const FiltersBlockMainDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  width:100%;
  padding-top:${props.theme.spacing.custom(30)};
  padding-bottom:${props.theme.spacing.custom(30)};
  padding-right:${props.theme.spacing.custom(20)};
  padding-left:${props.theme.spacing.custom(20)};
  border-bottom: 1px solid #e1e7ee;
  justify-content:space-between;
  align-items:center;

`,
);

export const FilterTextSpan = styled.span(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  font-size:${props.theme.font.large};
  font-family:${props.theme.font.fontFamily};
  font-weight:bold;

`,
);

export const ResetElink = styled.a(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  colors:${props.theme.colors.goBrand.blue};
  font-size:${props.theme.font.custom(12)};
  font-family:${props.theme.font.fontFamily};
  font-weight:bold;
  
`,
);

export const PopularBlockMainDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  width:100%;
  padding-top:${props.theme.spacing.large};
  padding-bottom:${props.theme.spacing.large};
  padding-right:${props.theme.spacing.custom(20)};
  padding-left:${props.theme.spacing.custom(20)};
  border-bottom: 1px solid #e1e7ee;

`,
);

export const PopularTextSpan = styled.span(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  font-size:${props.theme.font.custom(14)};
  font-family:${props.theme.font.fontFamily};
  font-weight:bold;

`,
);

export const PopularBlockInnerMainDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  width:100%;
  justify-content:space-between;
  align-items:center;

`,
);

export const NewFiltersMainDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  width:100%;
  padding-top:${props.theme.spacing.xlarge};
  padding-bottom:${props.theme.spacing.xlarge};


`,
);

export const DropPointFiltersMainDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}

  width:100%;
  margin-top:${props.theme.spacing.xlarge};
  overflow-y: auto;
  max-height: 30rem;
`,
);

export const BusTypeFiltersWrap = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  width:100%;
  justify-content: space-between;
  padding-top: 1rem
`,
);

export const BusTypeFilterTab = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  margin: 0.5rem 0;
  border-radius: 0.3rem;
  background-color: #f3f6f8;
  width:48%;
  padding: 0.7rem 0;
  font-size:1.2rem;
  align-items: center;
  justify-content: center;
  cursor:pointer;
  &.active{
    background-color: #2276e3;
    color:#ffffff;
    font-size:${props.theme.font.custom(11)};
    font-weight:bold;
  }

`,
);

export const CheckButtonWrap = styled.div(
  props => `
    display: flex;
    position: relative;
    align-items:center;
    cursor: pointer;
  `,
);

export const AmenitiesTxtSpan = styled.span(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}

  background-color:#f3f6f8;
  border-radius:0.3rem;
  padding:${props.theme.spacing.small};
  margin-left:${props.theme.spacing.base};
  margin-right:${props.theme.spacing.base};


`,
);

export const FilterTypeSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;

  font-size:${props.theme.font.custom(14)};
  &.active{
    color:#2276e3;
    font-size:${props.theme.font.custom(14)};
  }

`,
);

export const SourceTypeSpan = styled.span(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}

  padding-top:${props.theme.spacing.custom(3)};
  padding-left:${props.theme.spacing.base};

  font-size:${props.theme.font.custom(14)};
  &.active{
    color:#2276e3;
    font-size:${props.theme.font.custom(14)};
  }

`,
);

export const FilterOuterWrapperDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  padding-bottom:${props.theme.spacing.base};
  justify-content:space-between;
  width:100%;

`,
);
export const SelectedFilterWrap = styled.div`
  padding: 1.5rem 0 1rem;
  border-bottom: 1px solid #e1e7ee;
  width: 100%;
`;
export const BordingPointOuterWrapperDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  width:100%;
  padding-top:${props.theme.spacing.base};


`,
);

export const TextBoxContentDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  position: relative;
  width: 100%;

`,
);

export const TextBox = styled.input(
  props => `
  display: block;
  width: 100%;
  height: 4.2rem;
  padding: ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.base} 1rem;
  line-height: 1.3;
  border-radius: ${props.theme.misc.borderRadius.base};
  flex-direction: row;
  align-items: center;
  justify-conent: center;
  font-family: ${props.theme.font.fontFamily};
  font-size: ${props.theme.font.custom(14)};
  color: ${props.theme.colors.grey.grey50};
  background-color: ${props.theme.colors.white.base};
  border: 1px solid #979797;

  &::-webkit-input-placeholder {
  opacity: 0.5;
  ${TextBox}.font-size;
  ${TextBox}.font-family;
  ${TextBox}.font-weight;
  }
  &:focus {
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrand.blue}
  box-shadow: none;
  outline: none;
  }
  `,
);
